module.exports = __webpack_public_path__ + "static/img/4.dbae7073.png";